import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-147db618")

_pushScopeId("data-v-147db618")
const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "relative md:w-8/12 lg:w-5/12 flex flex-col h-screen bg-white" }
const _hoisted_3 = { class: "border-b py-4 border-gray-lp-400" }
const _hoisted_4 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4" }, " Upload Berkas ", -1)
const _hoisted_6 = { class: "px-8 pt-4 overflow-auto pb-20" }
const _hoisted_7 = { class: "text-12px xxl:text-14px text-gray-lp-500" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Pastikan selalu data yang Anda masukkan benar dan sesuai dengan filenya. Ikuti langsung cara mengisi template bulk upload ")
const _hoisted_9 = { class: "flex flex-col my-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Tipe Berkas ", -1)
const _hoisted_11 = { class: "flex flex-col my-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Nama Aktivitas ", -1)
const _hoisted_13 = { class: "inline-block relative z-10 w-full my-2 mr-4" }
const _hoisted_14 = { class: "z-10 w-full my-2 mr-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-500 w-full pr-16 leading-tight" }, " Pilih salah satu status commodity Surcharge yang ingin Anda Update ", -1)
const _hoisted_16 = { class: "flex flex-row gap-x-16 mt-1" }
const _hoisted_17 = { class: "p-field-radiobutton gap-x-3 flex flex-row" }
const _hoisted_18 = { class: "blok text-14px space-y-2 mt-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-500" }, " Pilih salah satu status promo yang ingin Anda Update ", -1)
const _hoisted_20 = { class: "flex flex-row gap-x-16 mt-3" }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { class: "flex flex-col my-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Nama Versi Retail Base Rate ", -1)
const _hoisted_24 = {
  key: 0,
  class: "inline-block relative z-10 w-full my-2 mr-4"
}
const _hoisted_25 = { class: "inline-block relative w-full" }
const _hoisted_26 = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mr-2"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "warning"
}, null, -1)
const _hoisted_28 = { class: "text-red-lp-700 text-12px xxl:text-14px" }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { class: "flex flex-col my-4" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Nama Client ", -1)
const _hoisted_32 = { class: "flex flex-col my-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Berkas Lampiran ", -1)
const _hoisted_34 = { key: 6 }
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_37 = { class: "z-10 w-full my-2 mr-4" }
const _hoisted_38 = { class: "text-12px xxl:text-14px text-gray-lp-500 w-full pr-16 leading-tight" }
const _hoisted_39 = { class: "flex flex-col my-4" }
const _hoisted_40 = { class: "flex flex-row" }
const _hoisted_41 = { class: "flex flex-col mr-2" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Dimulai Dari ", -1)
const _hoisted_43 = { class: "z-10 w-full my-2" }
const _hoisted_44 = { class: "flex flex-col ml-2" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Sampai ", -1)
const _hoisted_46 = { class: "z-10 w-full my-2 mr-4" }
const _hoisted_47 = { class: "text-red-lp-700 text-12px xxl:text-14px" }
const _hoisted_48 = { class: "text-red-lp-700 text-12px xxl:text-14px" }
const _hoisted_49 = {
  key: 0,
  class: "flex flex-col gap-y-3"
}
const _hoisted_50 = { class: "lp-checkbox p-field-checkbox flex items-center" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-12px text-gray-lp-300",
  for: "agreement-city-rate"
}, " Saya telah mengunggah city rate ", -1)
const _hoisted_52 = { class: "lp-checkbox p-field-checkbox flex items-center" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-12px text-gray-lp-300",
  for: "agreement-district-rate"
}, " Saya telah mengunggah district rate ", -1)
const _hoisted_54 = { key: 7 }
const _hoisted_55 = { class: "flex flex-col my-4" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }, " Tanggal Aktif Harga ", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-500 w-full pr-16 leading-tight" }, " Tanggal mulainya harga terbaru ", -1)
const _hoisted_58 = { class: "w-full z-20 absolute bottom-0 items-center flex flex-row rounded-b-md text-xs bg-gray-lp-700 justify-center md:justify-end px-8 py-4" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "flex flex-col" }
const _hoisted_62 = { class: "font-semibold" }
const _hoisted_63 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_LpRadioButton = _resolveComponent("LpRadioButton")!
  const _component_SelectSearchOriginDestination = _resolveComponent("SelectSearchOriginDestination")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none", {'pb-4': _ctx.isShowRunningText}]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("img", {
              src: _imports_0,
              class: "w-4 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCloseWithReset && _ctx.onCloseWithReset(...args))),
              alt: "x"
            })
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", {
              class: "text-red-lp-200 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.directTemplate && _ctx.directTemplate(...args)))
            }, "disini")
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Select, {
              dataSelect: _ctx.typeData,
              onOpenSelect: _ctx.onOpenTypeSelect,
              onCloseSelect: _ctx.onCloseTypeSelect,
              onChooseSelect: _ctx.onSelectType,
              value: _ctx.typeName,
              isOpenMenu: _ctx.typeSelect,
              class: "text-12px xxl:text-14px my-2 z-20",
              style: {"width":"18rem"},
              longTrim: 30
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
          ]),
          (_ctx.archiveType === 'update-retail-rate')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: "Status Versi"
              }, {
                default: _withId(() => [
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.statusVersionSelect,
                    "onUpdate:isExpand": _cache[3] || (_cache[3] = ($event: any) => (_ctx.statusVersionSelect = $event)),
                    options: _ctx.statusVersionData,
                    onSelect: _ctx.onSelectStatusVersion,
                    selectedItem: _ctx.statusVersion,
                    style: {"width":"18rem","margin-top":"8px"}
                  }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.activityName = $event)),
                class: "block appearance-none text-12px xxl:text-14px w-full bg-white border border-gray-lp-400 px-4 py-2 xxl:py-2.5 pr-16 rounded shadow leading-tight focus:outline-none",
                maxlength: 56,
                placeholder: "Masukkan nama aktivitas upload"
              }, null, 512), [
                [_vModelText, _ctx.activityName]
              ]),
              _createVNode("div", {
                class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-lp-500 mr-2 text-12px",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
              }, _toDisplayString(_ctx.activityName.length) + "/56 ", 1)
            ])
          ]),
          (_ctx.archiveType === 'update-commodity-surcharge')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: "Status Commodity Surcharge"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("div", _hoisted_16, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusSurcharges, (option) => {
                        return (_openBlock(), _createBlock("div", {
                          key: option.value,
                          class: "flex flex-col gap-y-4 mx-2 my-4 city-exclude-radio"
                        }, [
                          _createVNode("div", _hoisted_17, [
                            _createVNode(_component_RadioButton, {
                              id: `radio-${option.value}`,
                              name: "surcharge-status",
                              value: option.value,
                              modelValue: _ctx.statusSurcharge,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.statusSurcharge = $event)),
                              onChange: ($event: any) => (_ctx.onChangeStatusSurcharge(option.value))
                            }, null, 8, ["id", "value", "modelValue", "onChange"]),
                            _createVNode("label", {
                              for: `radio-${option.value}`,
                              class: "cursor-pointer"
                            }, _toDisplayString(option.name), 9, ["for"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.archiveType.match(/^update-custom-status$/gi))
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                label: "Status Terbaru",
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.isExpandCustomStatus,
                    "onUpdate:isExpand": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isExpandCustomStatus = $event)),
                    selectedItem: _ctx.customStatusOption,
                    options: _ctx.customStatusOptionData,
                    onSelect: _ctx.onSelectCustomStatusOption,
                    placeholder: "Pilih Status",
                    class: "w-full my-2"
                  }, null, 8, ["isExpand", "selectedItem", "options", "onSelect"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.archiveType.match(/^update-promo-discount$/gi))
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 3,
                label: "Status Promo",
                caption: "Pilih salah satu status promo yang ingin Anda Update",
                class: "my-6"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("div", _hoisted_20, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.promoStatusData, (item) => {
                        return (_openBlock(), _createBlock(_component_LpRadioButton, {
                          key: item.value,
                          modelValue: _ctx.archivePromoStatus,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.archivePromoStatus = $event)),
                          value: item.value,
                          label: item.name
                        }, null, 8, ["modelValue", "value", "label"]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.archiveType.includes('retail-rate'))
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  (_ctx.archiveType === 'retail-rate')
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.versionName = $event)),
                            onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getVersionName && _ctx.getVersionName(...args))),
                            placeholder: "Masukkan nama versi",
                            class: 
                      `block appearance-none text-12px xxl:text-14px w-full bg-white border px-4 py-2 xxl:py-2.5 pr-12 rounded leading-tight focus:outline-none border-gray-lp-400 ${
                        !_ctx.isVersionNameAvailable && _ctx.versionName.length >= 3
                          ? 'shadow-input-error'
                          : 'shadow'
                      }`
                    
                          }, null, 34), [
                            [_vModelText, _ctx.versionName]
                          ]),
                          (!_ctx.isVersionNameAvailable && _ctx.versionName.length >= 3)
                            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                _hoisted_27
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createBlock(_component_SelectSearchOriginDestination, {
                        key: 1,
                        placeholder: "Ketik atau pilih nama versi",
                        value: _ctx.versionNameValue,
                        dataSearch: _ctx.versionNameList,
                        onSearch: _ctx.onSearchVersionName,
                        onOpenSearch: _ctx.onOpenVersionName,
                        onCloseSearch: _ctx.onCloseVersionName,
                        onChooseSearch: _ctx.onChooseSelectVersionName,
                        isOpenSearch: _ctx.isVersionName,
                        notFound: _ctx.versionNameList.length === 0,
                        noSpaceLeft: false,
                        noSpaceRight: true,
                        isError: 
                  _ctx.versionNameList.length === 0 && _ctx.versionName.length >= 3
                ,
                        class: "my-2"
                      }, null, 8, ["value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound", "isError"])),
                  _withDirectives(_createVNode("span", _hoisted_28, "Nama versi harga sudah digunakan", 512), [
                    [_vShow, !_ctx.isVersionNameAvailable && _ctx.versionName.length >= 3]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.archiveType.includes('client-location'))
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_SelectSearchOriginDestination, {
                    placeholder: "Ketik atau pilih nama client",
                    value: _ctx.clientNameDisplay,
                    dataSearch: _ctx.clientNameList,
                    onSearch: _ctx.onSearchClientName,
                    onOpenSearch: _ctx.onOpenClientName,
                    onCloseSearch: _ctx.onCloseClientName,
                    onChooseSearch: _ctx.onChooseSelectSearchClientName,
                    isOpenSearch: _ctx.isClientName,
                    notFound: _ctx.clientNameList.length === 0,
                    noSpaceLeft: false,
                    noSpaceRight: true,
                    class: "my-2"
                  }, null, 8, ["value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_UploadFile, _mergeProps({
              modelValue: _ctx.archiveFile,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.archiveFile = $event)),
              isClear: _ctx.isClearFile,
              "onUpdate:isClear": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isClearFile = $event)),
              statusReset: _ctx.statusReset,
              checkColumn: _ctx.checkColumn
            }, _ctx.configUploadFile, { archiveType: _ctx.archiveType }), null, 16, ["modelValue", "isClear", "statusReset", "checkColumn", "archiveType"])
          ]),
          (_ctx.ableToViewPeriode)
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, " Periode " + _toDisplayString(_ctx.periodTitle), 1),
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, " Periode " + _toDisplayString(_ctx.periodTitle) + " akan berlaku sesuai dengan tanggal periode yang dipilih. ", 1)
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _createVNode("div", _hoisted_40, [
                      _createVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createVNode("div", _hoisted_43, [
                          _createVNode(_component_Pickers, {
                            modelValue: _ctx.retailStart,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.retailStart = $event)),
                            onSelected: _cache[14] || (_cache[14] = retailStart => _ctx.inputDateStart(retailStart)),
                            disabled: 
                          _ctx.invalidEndDate ||
                            _ctx.archiveType === 'update-retail-rate' ||
                            _ctx.archiveType === 'update-embargo' ||
                            _ctx.archiveType === 'client-location-update' ||
                            (_ctx.archiveType === 'update-commodity-surcharge' && _ctx.statusSurcharge === 'active')
                        ,
                            minDate: 
                          _ctx.archiveType.includes('retail-rate')
                            ? null
                            : new Date(
                                new Date().setDate(new Date().getDate() + 1)
                              )
                        
                          }, null, 8, ["modelValue", "disabled", "minDate"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode("div", _hoisted_46, [
                          _createVNode(_component_Pickers, {
                            modelValue: _ctx.retailEnd,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.retailEnd = $event)),
                            onSelected: _cache[16] || (_cache[16] = retailEnd => _ctx.inputDateEnd(retailEnd)),
                            disabled: 
                          _ctx.invalidStartDate ||
                            _ctx.archiveType === 'update-retail-rate'
                        ,
                            minDate: _ctx.minEndDate
                          }, null, 8, ["modelValue", "disabled", "minDate"])
                        ])
                      ])
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_47, " Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir ", 512), [
                      [_vShow, _ctx.invalidStartDate]
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_48, " Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai ", 512), [
                      [_vShow, _ctx.invalidEndDate]
                    ])
                  ]),
                  (
                  _ctx.archiveType.includes('retail-rate') ||
                    _ctx.archiveType.includes('create-commodity-surcharge') ||
                    _ctx.archiveType.includes('update-commodity-surcharge')
                )
                    ? (_openBlock(), _createBlock("div", _hoisted_49, [
                        _createVNode("div", _hoisted_50, [
                          _createVNode(_component_Checkbox, {
                            id: "agreement-city-rate",
                            modelValue: _ctx.agreementCityRate,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.agreementCityRate = $event)),
                            binary: true
                          }, null, 8, ["modelValue"]),
                          _hoisted_51
                        ]),
                        _createVNode("div", _hoisted_52, [
                          _createVNode(_component_Checkbox, {
                            id: "agreement-district-rate",
                            modelValue: _ctx.agreementDistrictRate,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.agreementDistrictRate = $event)),
                            binary: true
                          }, null, 8, ["modelValue"]),
                          _hoisted_53
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.archiveType.includes('update-retail-rate'))
            ? (_openBlock(), _createBlock("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode(_component_Pickers, {
                    class: "mt-3 w-6/12",
                    modelValue: _ctx.rateActiveDate,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.rateActiveDate = $event)),
                    minDate: 
                  new Date(new Date().setDate(new Date().getDate() + 1))
                
                  }, null, 8, ["modelValue", "minDate"]),
                  _hoisted_57
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_58, [
          _createVNode(_component_button_outline, {
            custom: "bg-white px-12 border border-red-lp-100 text-red-lp-200 mr-4",
            title: "Cancel",
            onClick: _ctx.onCloseWithReset
          }, null, 8, ["onClick"]),
          _createVNode(_component_button_fill, {
            custom: "px-12 bg-red-lp-200",
            title: "Upload",
            onClick: _ctx.onSubmit,
            isLoading: _ctx.isLoading,
            isDisabled: _ctx.isDisabled
          }, null, 8, ["onClick", "isLoading", "isDisabled"])
        ])
      ])
    ], 2),
    _hoisted_59,
    (_ctx.openNotification && !!_ctx.allNotifications.length)
      ? (_openBlock(), _createBlock("div", _hoisted_60, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allNotifications, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: item,
              class: "absolute z-50 flex flex-row max-w-sm text-12px xxl:text-14px top-0 right-0 mr-4 items-start py-4 px-4 shadow-lg border border-gray-lp-400 rounded-lg bg-white",
              style: `margin-top: ${index * 100 + 20}px`
            }, [
              _createVNode("img", {
                src: 
            require(`@/app/ui/assets/svg/${
              _ctx.type.toLowerCase().includes('sukses') ? 'success' : 'x-circle'
            }.svg`)
          ,
                class: "w-6 mr-2",
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, _toDisplayString(_ctx.type), 1),
                _createVNode("div", _hoisted_63, _toDisplayString(_ctx.message), 1)
              ]),
              _createVNode("img", {
                src: _imports_0,
                class: "w-4 ml-2 cursor-pointer",
                onClick: ($event: any) => (_ctx.onCloseNotification(index)),
                alt: "x"
              }, null, 8, ["onClick"])
            ], 4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})